<template>
  <div>
    <v-card>
      <v-card-title>
        Conta Corrente
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="mx-2"
              large
              @click="$emit('togglePrint')"
              :disabled="!selectedClient.name"
            >
              <v-icon dark color="green">mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-select
          v-model="balanceAddressId"
          :items="addresses"
          item-text="value"
          item-value="id"
          label="Loja"
          @change="getBalance()"
          outlined
          :disabled="!selectedClient.name"
        ></v-select>
      </v-card-title>
      <v-data-table
        :headers="headersBalance"
        :items="currentBalance"
        hide-default-footer
        item-key="name"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer />
            <v-switch
              style="font-weight: bold"
              @change="$emit('toggleDefaultCurrency')"
              :label="`Converter Valores para : ${defaultCurrency}`"
            ></v-switch>
          </v-toolbar>
        </template>
        <template v-slot:[`item.currency`]="{ item }">{{
          showDefaultCurrency ? defaultCurrency : item.currency
        }}</template>
        <template v-slot:[`item.totalCredit`]="{ item }">{{
          showDefaultCurrency
            ? item.totalCreditMain.toFixed(2)
            : item.totalCredit.toFixed(2)
        }}</template>
        <template v-slot:[`item.totalDebit`]="{ item }">{{
          showDefaultCurrency
            ? item.totalDebitMain.toFixed(2)
            : item.totalDebit.toFixed(2)
        }}</template>
        <template v-slot:[`item.balance`]="{ item }">{{
          showDefaultCurrency
            ? (item.totalDebitMain - item.totalCreditMain).toFixed(2)
            : (item.totalDebit - item.totalCredit).toFixed(2)
        }}</template>
      </v-data-table>

      <v-overlay :absolute="true" :value="balanceOverlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import ServiceLedger from "@/services/ServiceLedger";
export default {
  name: "balance-viewer",
  props: [
    "selectedClient",
    "defaultCurrency",
    "addresses",
    "showDefaultCurrency",
  ],
  data() {
    return {
      balanceAddressId: null,
      currentBalance: [],
      balanceOverlay: false,
      headersBalance: [
        { text: "Total Débito", value: "totalDebit", sortable: false },
        { text: "Total Crédito", value: "totalCredit", sortable: false },
        { text: "Balanço", value: "balance", sortable: false },
        { text: "Moeda", value: "currency", sortable: false },
      ],
    };
  },
  methods: {
    setCurrentBalance(currBalance) {
      this.currentBalance = currBalance;
    },
    async getBalance() {
      try {
        this.balanceOverlay = true;

        if (this.$store.state.user.level == 2) {
          this.currentBalance = (
            await ServiceLedger.getBalanceAdmin(
              this.selectedClient.id,
              this.balanceAddressId
            )
          ).data;
        }

        if (this.$store.state.user.level == 1) {
          this.currentBalance = (
            await ServiceLedger.getBalanceSalesman(
              this.selectedClient.id,
              this.balanceAddressId
            )
          ).data;
        }

        if (this.$store.state.user.level == 0) {
          this.currentBalance = (
            await ServiceLedger.getBalance(this.balanceAddressId)
          ).data;
        }

        this.balanceOverlay = false;
      } catch (error) {
        this.balanceOverlay = false;
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error,
        });
      }
    },
  },
};
</script>
<style>
</style>
